/** Empresa del listado del grupo (fila seleccionada en la grilla de empresas). */
export type EmpresaGrupoResumen = {
  rfc?: string | null;
  razonSocial?: string | null;
};

/**
 * Título de panel secundario: "RFC Razón social - Etiqueta" si hay empresa seleccionada.
 */
export function buildGrupoPanelTitle(
  panelLabel: string,
  empresa?: EmpresaGrupoResumen | null,
): string {
  if (empresa == null) return panelLabel;
  const rfc = empresa.rfc != null ? String(empresa.rfc).trim() : '';
  const razonSocial = empresa.razonSocial != null ? String(empresa.razonSocial).trim() : '';
  if (!rfc && !razonSocial) return panelLabel;
  const empresaLabel = [rfc, razonSocial].filter(Boolean).join(' ');
  return `${empresaLabel} - ${panelLabel}`;
}

export function findEmpresaEnGrupo(
  empresas: readonly EmpresaGrupoResumen[] | null | undefined,
  empresaId: string | undefined,
): EmpresaGrupoResumen | null {
  if (empresaId == null || empresaId === '' || empresaId === 'new' || empresas == null) {
    return null;
  }
  const id = Number(empresaId);
  if (Number.isNaN(id)) return null;
  const found = empresas.find((e: any) => Number(e?.id) === id);
  return found ?? null;
}
